angular.module('galilai.creator').controller('CreditsController', function ($scope, api, $timeout, $rootScope) {
    $scope.plans = []
    $scope.loading = false
    $scope.pixEnabled = getCurrentLanguage() == 'pt' // Only show pix for BR, as it's the only supported region for now

    $scope.multiplier = 1
    const baseCreditsExample = 100
    const CREDITS_PER_PAGE = 10;

    $scope.select = function (plan) {
        $scope.selectedPlan = plan;
    };

    $scope.credits = null

    $rootScope.$on('credits.show', function() {
        $scope.loading = true

        // Busca o saldo antes de decidir qual tela abrir. O critério é o `planTotal` do
        // backend, e não o hasSomeActivePlan(): aquele helper lê billing.customer + plan.id,
        // enquanto a cota é concedida por billing.status. Os dois divergem no caminho do
        // startWithoutPayment, que grava customer e plano mas nunca grava status — esse
        // usuário cairia num modal dizendo "sua cota acabou" sem nunca ter tido cota.
        api.getCurrentCredits().then(function(res) {
            $scope.credits = res.data

            // Sem cota do plano: o caminho certo é assinar, não comprar avulso — sai mais
            // barato por design para ele e gera recorrência.
            if (!res.data.planTotal) {
                // O #plans-modal não tem z-index explícito (fica no default do Bootstrap),
                // enquanto o #postgen-modal está em 110000. Sem esconder a origem, a tela
                // de planos abriria atrás e o usuário não veria nada.
                angular.element('#credits-modal').modal('hide');
                angular.element('#postgen-modal').modal('hide');
                angular.element('#postgen-editor-modal').modal('hide');
                $rootScope.showUpgrade('no_credits')
                return
            }

            angular.element('#credits-modal').modal('show');

            return api.getCreditPackages().then(function(res) {
                $scope.plans = res.data
                $scope.selectedPlan = $scope.plans[1];
                if ($scope.plans[0].originalCredits && $scope.plans[0].credits > $scope.plans[0].originalCredits) {
                    $scope.multiplier = $scope.plans[0].credits / $scope.plans[0].originalCredits
                    $scope.multiplier = Math.round($scope.multiplier * 100) / 100
                }
                $timeout(angular.noop)
            })
        })
        .catch(function(err) {
            console.error('Error loading credits', err)
        })
        .finally(function() {
            $scope.loading = false
            $timeout(angular.noop)
        })
    })

    let intervalCredits =  null
    function monitorCredits(currentCredits, plan) {
        if (intervalCredits) {
            clearInterval(intervalCredits)
        }
        intervalCredits = setInterval(function() {
            api.getCurrentCredits().then(function(res) {
                if (res.data.credits > currentCredits) {
                    showSuccess(gettext('credits.purchased_success'))
                    trackPurchase(plan?.price)
                    angular.element('#credits-modal').modal('hide');
                    clearInterval(intervalCredits)
                    $rootScope.$emit('credits.updated', res.data.credits)
                }
            }).catch(function(err) {
                console.error('Error fetching credits', err)
            })
        }, 5000)
    }

    $scope.purchase = function(plan, kind) {
        $scope.loading = true
        api.purchaseCredits(plan.id, kind).then(function(res) {
            let currentCredits = res.data.credits
            if (res.data.pix) {
                let image = `<img class="img-fluid" src="data:image/png;base64,${res.data.pix.encodedImage}" alt="PIX QR Code" />`

                let input = `
                    <div style="display:flex; gap:8px; margin-top: -25px">
                        <input id="pixPayloadInput" type="text" class="form-control" value="${res.data.pix.payload}" readonly />
                        <button class="btn btn-primary"
                            onclick="
                                var btn = this;
                                var value = document.getElementById('pixPayloadInput').value;
                                navigator.clipboard.writeText(value).then(function () {
                                    btn.innerText = '${gettext('generic.copied')}';
                                    setTimeout(function () {
                                        btn.innerText = '${gettext('generic.copy')}';
                                    }, 1500);
                                });
                            ">
                            ${gettext('generic.copy')}
                        </button>
                    </div>
                `
                let modalInstance = showSuccess(
                    input + image,
                    gettext('credits.package').replace('%s', plan.credits)
                )

                $scope.monitorJob(res.data.pix.jobId, modalInstance, plan);
            }
            else if (res.data.url) {
                window.open(res.data.url, '_blank');
                monitorCredits(currentCredits, plan);
            } else if (res.data.success) {
                showSuccess(gettext('credits.purchased_success'))
                trackPurchase(plan?.price)
                angular.element('#credits-modal').modal('hide');
                $rootScope.$emit('credits.updated', res.data.credits)
            }
        })
        .finally(function() {
            $scope.loading = false
        })
    }

    let intervalCheckout= null;
    $scope.monitorJob = function(jobId, modalInstance, plan) {
        if (intervalCheckout) {
            clearInterval(intervalCheckout);
        }
        if (!jobId) {
            showError(gettext('error.generic'))
            return;
        }
        intervalCheckout = setInterval(() => {
            api.getJob(jobId).then(res => {
                if (res.data && res.data.status != 'pending') {
                    clearInterval(intervalCheckout)
                    if (res.data && res.data.status == 'success') {
                        try {
                            modalInstance.hide();
                        } catch(e) {
                        }
                        setTimeout(() => {
                            showSuccess(gettext('credits.purchased_success'))
                            trackPurchase(plan?.price)
                            $rootScope.$emit('credits.refresh')
                            clearInterval(intervalCheckout)
                            angular.element('#credits-modal').modal('hide');
                        }, 1000)
                    } else {
                        clearInterval(intervalCheckout)
                        showError(gettext('error.generic'))
                    }
                }
            }).catch(e => {
                clearInterval(intervalCheckout)
                showError(gettext('error.generic'))
            })
        }, 2000)
    }

    function trackPurchase(value) {
        try {
            let params = {
                'send_to': 'AW-975659227/m5uCCKStsqocENvBndED',
                'currency': 'BRL',
            }
            if (value) {
                params.value = value
            }
            gtag('event', 'conversion', params);
        } catch (e) {
            console.error('Error tracking purchase:', e);
        }
    }

    $scope.getCreditsExplainMessage = function() {
        return gettext('user_credits.usage_explanation').replace('%s', CREDITS_PER_PAGE);
    }

    // Explica a situação da cota. O modal abre tanto quando a geração falha por falta de
    // crédito quanto quando o usuário clica em comprar por vontade própria — então não dá
    // para assumir que a cota acabou. Quem não tem cota nenhuma nem chega aqui: o handler
    // de credits.show manda direto para a tela de planos.
    $scope.getQuotaMessage = function() {
        const credits = $scope.credits
        if (!credits || !credits.planTotal || !credits.planResetsAt) {
            return gettext('user_credits.subtitle')
        }

        // planResetsAt é o fim do mês às 23:59:59; a cota nova entra no instante seguinte,
        // então o que interessa mostrar é o dia da renovação.
        const renew = new Date(new Date(credits.planResetsAt).getTime() + 1000)
        if (isNaN(renew.getTime())) {
            return gettext('user_credits.subtitle')
        }
        const date = ('0' + renew.getDate()).slice(-2) + '/' + ('0' + (renew.getMonth() + 1)).slice(-2)

        // Sobra menor que um design conta como esgotada — não adianta dizer "você ainda
        // tem 0 designs".
        const designsLeft = Math.floor(credits.plan / CREDITS_PER_PAGE)

        let message
        if (designsLeft > 0) {
            // Ainda tem cota: usa o saldo restante, não a cota configurada. Os dois podem
            // divergir quando a cota do plano muda no meio do ciclo (o lote já concedido
            // só sobe, nunca desce).
            message = gettext('credits.quota_remaining')
                .replace('$VAR1', designsLeft)
                .replace('$VAR2', date)
        } else {
            message = gettext('credits.quota_exhausted')
                .replace('$VAR1', Math.floor(credits.planTotal / CREDITS_PER_PAGE))
                .replace('$VAR2', date)
        }
        return message + ' ' + gettext('credits.buy_more')
    }

    $scope.getBonusCreditsMessage = function() {
        // Use multiplier
        if ($scope.multiplier > 1) {
            let bonusPercentage = Math.round(($scope.multiplier - 1) * 100)
            return gettext('features.bonus_plan').replace('$VAR', bonusPercentage)
        } else {
            return gettext('features.bonus_plan_none')
        }
    }

    $scope.getBonusCreditsExampleMessage = function() {
        let creditsBonus = Math.round(baseCreditsExample * ($scope.multiplier - 1))
        if ($scope.multiplier == 1) {
            creditsBonus = 1 * baseCreditsExample
        }
        return gettext('features.bonus_plan_example').replace('$VAR', creditsBonus)
    }

    $scope.showPlanSelection = function() {
        $rootScope.showUpgrade('credits_bonus', {
            track: false
        })
    }

    $scope.chooseTemplate = function() {
        angular.element("#credits-modal").modal("hide");
        angular.element("#postgen-modal").modal("hide");
        $rootScope.$broadcast("generate.chooseModes");
    }
})